var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 19.2,
    height: 13.8,
    viewBox: "0 0 19.2 13.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0.9,1.8l7.4,6.5c0.7,0.6,1.8,0.6,2.5,0l7.4-6.5v0.1V12c0,0.5-0.4,0.9-0.9,0.9H1.8c-0.5,0-0.9-0.4-0.9-0.9V1.8L0.9,1.8  M1.8,0.9h15.6c0.1,0,0.3,0,0.4,0.1l-7.5,6.5C9.9,7.9,9.4,7.9,9,7.5L1.4,1C1.4,0.9,1.7,0.9,1.8,0.9 M1.8,0C0.8,0,0,0.8,0,1.9V12 c0,1,0.8,1.8,1.8,1.8h15.6c1,0,1.8-0.8,1.8-1.8V1.9c0-1-0.8-1.9-1.8-1.9L1.8,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.4133887df01533c2365579f6ec1ab979.svg";
export { ForwardRef as ReactComponent };